export default __webpack_public_path__ + "static/media/empty_history.7a251309.png";